import "components/jiffy/user-login/user-login";
import initUserRegistration, {
  initPhoneFormatting
} from "components/jiffy/user-registration/user-registration";
import "components/jiffy/user-reset-password/user-reset-password";
import "components/jiffy/user-set-password/user-set-password";

document.addEventListener("DOMContentLoaded", () => {
  initUserRegistration();
  initPhoneFormatting();
});
